<div class="filterBadges region-filter-badges"></div>
<div class="auxControls region-aux-control"></div>